import { useOktaAuth } from '@okta/okta-react';
import { Navigate, RouteProps, useLocation } from 'react-router-dom';

type Props = RouteProps & {
  loginUrl: string;
  onAuthRequired: VoidFunction;
};
export const AuthenticatedRoute = ({ children, ...rest }: Props) => {
  const { authState } = useOktaAuth();
  const { loginUrl } = rest;
  const location = useLocation();

  if (!authState) {
    return <></>;
  }

  if (!authState.isAuthenticated) {
    // if (onAuthRequired) {
    //   onAuthRequired();
    // } else {
    //   oktaAuth.signInWithRedirect({
    //     originalUri: location.pathname,
    //   });
    // }

    return <Navigate to={loginUrl} state={{ from: location }} />;
  }

  return children;
};
